// https://stackoverflow.com/questions/14833326
angular.module('leanlaw').directive("focusMe", ['$timeout', '$parse', function ($timeout, $parse) {
  return {
    scope: {
      focusMe: "=",
      // Needed for when a function return value is passed as focusMe:
      ignoreBlur: "=?"
    },
    link: function (scope, element, attrs) {
      const focusHandler = newValue => {
        // Only focus when value changes to true explicitly
        if (newValue !== true) return;
        scope.focus();
      };
      scope.$watch("focusMe", focusHandler);

      // if (scope.focusMe == true)
      //     scope.focus();

      scope.focus = function () {
        $timeout(() => {
          // Wait for Angular to release form element
          // Similar to node's setImmediate call

          element[0].focus();
          $(element[0]).trigger("chosen:activate");
        });
      };

      // Set the focus var to false on change
      element.bind("blur", () => {
        if (!scope.ignoreBlur) scope.focusMe = false;
      });
    }
  };
}]);